import React from "react";
import { PhoneCaseCustomizationInfo } from "@/dto/order/CustomizationInfoDTO";
import CustomizationInfoV2 from "../../../column/CustomizationInfoColumn/CustomizationInfoV2";

interface PhoneCaseCustomizationInfoColumnProps {
    phoneCaseCustomizationInfos: PhoneCaseCustomizationInfo[];
}

const PhoneCaseCustomizationInfoColumn: React.FC<PhoneCaseCustomizationInfoColumnProps> = React.memo(function (props) {
    const { phoneCaseCustomizationInfos } = props;

    return (
        <div className="customization-info-container">
            {phoneCaseCustomizationInfos?.length ? <p className="mb5">定制图：</p> : null}

            {phoneCaseCustomizationInfos?.map((info, index) => {
                return <CustomizationInfoV2 info={info} key={index} />;
            })}
        </div>
    );
});

export default PhoneCaseCustomizationInfoColumn;
